import { isAdminRole, isSuperAdmin, UserRole } from '../../lib/roles';

interface LayoutUser {
  role: UserRole;
}

export interface LayoutNavItem {
  path: string;
  label: string;
  icon?: string;
}

export function createPrimaryNavItems(user: LayoutUser | null): LayoutNavItem[] {
  const items: LayoutNavItem[] = [
    { path: '/', label: '首页', icon: 'home' },
    { path: '/video-projects', label: '我的项目', icon: 'video' },
    { path: '/knowledge', label: '知识库', icon: 'book' },
  ];

  if (user) {
    items.splice(2, 0, { path: '/video-assets', label: '我的资产', icon: 'assets' });
    items.push({ path: '/recharge', label: '充值中心', icon: 'recharge' });
  }

  if (isAdminRole(user?.role)) {
    items.push({ path: '/admin', label: '管理', icon: 'admin' });
    items.push({ path: '/admin/monitoring', label: '监控', icon: 'activity' });
  }

  if (isSuperAdmin(user?.role)) {
    items.push({ path: '/admin/points', label: '积分管理', icon: 'points' });
  }

  return items;
}

export function createCommandItems(user: LayoutUser | null): LayoutNavItem[] {
  const items: LayoutNavItem[] = [
    { label: '首页', path: '/', icon: 'home' },
    { label: '我的项目', path: '/video-projects', icon: 'video' },
    { label: '知识库', path: '/knowledge', icon: 'book' },
  ];

  if (user) {
    items.splice(2, 0, { label: '我的资产', path: '/video-assets', icon: 'assets' });
    items.push({ label: '充值中心', path: '/recharge', icon: 'recharge' });
    items.push({ label: '个人中心', path: '/profile', icon: 'profile' });
  }

  if (isAdminRole(user?.role)) {
    items.push({ label: '管理后台', path: '/admin', icon: 'admin' });
    items.push({ label: '系统监控', path: '/admin/monitoring', icon: 'activity' });
  }

  if (isSuperAdmin(user?.role)) {
    items.push({ label: '积分管理', path: '/admin/points', icon: 'points' });
  }

  return items;
}
